var RoleCategoryService = (function () {
    function RoleCategoryService($http) {
        this.$http = $http;
        this.WsUrl = ResolveUrl("~/LoanData.asmx");
    }
    RoleCategoryService.prototype.getAll = function () {
        return this.$http.post(this.WsUrl + "/GetAllRoleCategory", {});
    };
    RoleCategoryService.$inject = ["$http"];
    return RoleCategoryService;
}());
angular
    .module("London.Services")
    .service("RoleCategoryService", RoleCategoryService);
